<div *transloco="let t" class="business-equipment-form">
  <div class="loading" *ngIf="loading" [ngClass]="{'not-registration': !isRegistration}">
    <mat-spinner></mat-spinner>
  </div>
  <div [formGroup]="businessEquipmentFormGroup"
       id="businessEquipmentForm">
    <app-paragraph *ngIf="showAddingEquipmentButton" class="business-equipment-register-info">
      {{t('business-equipment-register-info')}}
    </app-paragraph>
    <div *ngIf="isRegistration" class="validate-country">
      <app-select
        [label]="t('country')"
        [control]="countryFormGroup.controls.country"
        [options]="countries"
        [hasIdAndValue]="true"
        required
        (selectionChange)="getProvinces(true)"
        [disabled]="getCountryFieldState()">
      </app-select>
    </div>
    <app-label *ngIf="serverError" isError>
      {{equipmentData.labels.invalidSerialErrorMessage}}
    </app-label>
    <app-label *ngIf="equipmentExistsError" isError>
      {{equipmentData.labels.equipmentExistsError}}
    </app-label>
    <div class="equipment-row" formArrayName="equipments">
      <div *ngFor="let equipment of equipmentFormGroups; let i = index;">
        <app-business-equipment-tuple [formGroup]="equipment"
                                      [label]="equipmentData.labels.serial"
                                      [index]="i"
                                      (removeTuple)="deleteEquipment($event)"
                                      [hasMoreEquipment]="this.formArray.length > 1"></app-business-equipment-tuple>
      </div>
    </div>
    <app-label class="feedback-label" isGray *ngIf="feedbackLabel && !pendingProductRegistration">{{t(feedbackLabel)}} <mat-icon>check_circle</mat-icon></app-label>
    <div *ngIf="canAddNewEquipment() && showAddingEquipmentButton" class="business-equipment-area">
      <app-icon-button id="add-equipment"
                       icon="add_box"
                       type="submit"
                       (clickAction)="addTuple()">
        {{ equipmentData.labels.addEquipment }}
      </app-icon-button>
    </div>
  </div>
  <div *ngIf="pendingProductRegistration && showAddingEquipmentButton" class="pending-product-registration">
    <app-label class="pending-product-label bold">{{t('this-product-still-needs-registered')}}</app-label>
    <app-paragraph>
      {{t('your-printer-is-not-registered-info')}}
    </app-paragraph>
    <div class="unregistered-equipment">
      <app-header>{{t('modelname-register-data', { planModel: getControl(-1, 'planModel').value }) }} </app-header>
      <div class="unregistered-equipment-form">
        <app-input id="place-of-purchase"
                   [label]="t('place-of-purchase')"
                   [control]="registerEquipmentFormGroup.controls.placeOfPurchase"
                   required></app-input>
        <app-input id="installation-date"
                   [datepicker]="installationDate"
                   [label]="t('installation-date')"
                   [control]="registerEquipmentFormGroup.controls.installationDate"
                   required
                   maxDate="{{today}}"></app-input>
        <mat-datepicker #installationDate></mat-datepicker>
      </div>
    </div>
    <ng-container *ngIf="!isAddingEquipment">
      <app-header>{{t('business-registration-data')}}</app-header>
      <div class="business-registration-form">
        <app-input class="full-line"
                   [label]="t('business-name')"
                   [control]="registerEquipmentFormGroup.controls.businessName"
                   required></app-input>
        <app-input class="half-line-left"
                   [label]="t('representative-name')"
                   [control]="registerEquipmentFormGroup.controls.representativeName"
                   required></app-input>
        <app-input class="half-line-right"
                   [label]="t('representative-last-name')"
                   [control]="registerEquipmentFormGroup.controls.representativeLastName"
                   required></app-input>
        <app-input class="full-line"
                   [label]="t('business-email')"
                   [control]="registerEquipmentFormGroup.controls.businessEmail"
                   [type]="businessContactEmailInputType"
                   required></app-input>
        <app-select class="half-line-left"
                    [label]="t('country')"
                    [control]="countryFormGroup.controls.country"
                    [options]="countries"
                    [hasIdAndValue]="true"
                    required
                    (selectionChange)="getProvinces(true)"
                    [disabled]="getCountryFieldState()"></app-select>
        <app-select class="half-line-right"
                    [label]="t('state-or-region')"
                    [control]="registerEquipmentFormGroup.controls.stateOrRegion"
                    [options]="getProvinces()"
                    [hasIdAndValue]="true"
                    [isValueString]="true"
                    required></app-select>
        <app-input class="half-line-left"
                   [label]="t('primary-phone')"
                   required
                   [control]="registerEquipmentFormGroup.controls.primaryPhone"></app-input>
        <div class="phone-types half-line-right">
          <div class="radio-button">
            <input type="radio"
                   id="cell-phone"
                   name="phone-type"
                   value="mobile"
                   [formControl]="registerEquipmentFormGroup.controls.phoneType">
            <label for="cell-phone">{{t('cell-phone')}}</label>
          </div>
          <div class="radio-button">
            <input type="radio"
                   id="business-line"
                   name="phone-type"
                   value="land"
                   [formControl]="registerEquipmentFormGroup.controls.phoneType">
            <label for="business-line">{{t('business-line')}}</label>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <app-label *ngIf="showAddingEquipmentButton" isGray class="mandatory-fields">*{{t('mandatory-fields')}}</app-label>
  <app-checkbox *ngIf="pendingProductRegistration && showAddingEquipmentButton"
                id="register-equipments-agree-checkbox"
                [formGroup]="registerEquipmentFormGroup"
                abstractFormControlName="agree">
    {{t('register-equipment-agree-pre-privacy-policy-info')}}
    <app-anchor target="_blank" [href]="privacyLink">{{t('privacy-policy') | lowercase}}</app-anchor>
    {{t('register-equipment-agree-post-privacy-policy-info')}}
  </app-checkbox>
</div>
